var _path, _mask, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHusaText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 17,
    viewBox: "0 0 119 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20744 4V8.04263H3.79322V4H0V16H3.79322V11.8295H6.20744V16H10V4H6.20744Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 11,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3755 0.145386H22.4825V16.9998H12.3755V0.145386Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2957 1.54204L16.9084 3.96784L15.5908 2.92286L17.4865 0.145264L19.2957 1.54204ZM22.4825 4.10242V11.6119C22.4825 15.3162 20.4827 16.9999 17.4282 16.9999C14.3736 16.9999 12.3755 15.3162 12.3755 11.6119V4.10242H16.3436V11.1741C16.3436 12.1674 16.3718 13.0437 17.4282 13.0437C18.4846 13.0437 18.5141 12.1674 18.5141 11.1741V4.10242H22.4825Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5949 12.2519L24.7965 12.4375C25.5062 13.0758 26.3614 13.5976 27.2743 13.5976C27.6637 13.5976 28.2866 13.4127 28.2866 12.8399C28.2866 12.2682 27.7638 12.2182 27.4032 12.1325L26.6083 11.9649C25.058 11.6444 23.754 10.5852 23.754 8.59756C23.754 5.58301 26.1138 3.89966 28.4901 3.89966C29.7338 3.89966 30.8767 4.25215 31.9487 5.01056L30.8767 8.26033C30.1982 7.72223 29.4292 7.3007 28.5756 7.3007C28.2282 7.3007 27.7208 7.45231 27.7208 7.9748C27.7208 8.44629 28.214 8.51325 28.5176 8.59756L29.4153 8.83243C31.0945 9.27096 32.3104 10.3149 32.3104 12.4704C32.3104 15.5016 29.937 17.0001 27.5772 17.0001C26.2013 17.0001 24.6099 16.5626 23.3784 15.8371L24.5949 12.2519Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0836 12.2005L38.6202 9.96029C38.5049 9.42288 38.4326 8.86605 38.3597 8.3269H38.2161L37.4912 12.2005H39.0836ZM36.4634 16.7984H32.2666L36.0587 4.10217H40.4458L44.34 16.7984H40.1408L39.7795 15.215H36.7816L36.4634 16.7984Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5279 12.2519L45.7301 12.4375C46.4394 13.0758 47.2923 13.5976 48.2059 13.5976C48.5964 13.5976 49.2195 13.4127 49.2195 12.8399C49.2195 12.2682 48.6978 12.2182 48.3371 12.1325L47.5399 11.9649C45.9893 11.6444 44.6863 10.5852 44.6863 8.59756C44.6863 5.58301 47.0467 3.89966 49.4227 3.89966C50.6671 3.89966 51.8097 4.25215 52.8814 5.01056L51.8097 8.26033C51.1315 7.72223 50.3635 7.3007 49.5089 7.3007C49.1615 7.3007 48.6547 7.45231 48.6547 7.9748C48.6547 8.44629 49.1459 8.51325 49.4499 8.59756L50.3489 8.83243C52.0288 9.27096 53.2423 10.3149 53.2423 12.4704C53.2423 15.5016 50.8706 17.0001 48.5115 17.0001C47.1336 17.0001 45.5418 16.5626 44.311 15.8371L45.5279 12.2519Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9347 4.10242H60.0169L61.5237 10.7695H61.6252C61.6958 10.2148 61.7687 9.62395 61.8996 9.0855L63.1307 4.10242H67.1691L68.9634 16.7983H65.1282L64.5925 9.84321H64.5213C64.4477 10.2651 64.3754 10.7033 64.2588 11.1057L62.6813 16.7983H60.3646L58.9465 11.4259C58.8302 10.8868 58.7284 10.383 58.7012 9.84321H58.5703C58.5405 10.348 58.5116 10.8705 58.4679 11.3753L58.0051 16.7983H54.1689L55.9347 4.10242Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6123 16.7984H74.5784V4.10254H70.6123V16.7984Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2805 9.60636H82.2938V11.4094H81.2805V12.9928H81.5245C82.8441 12.9928 83.8564 12.2861 83.8564 10.618C83.8564 8.83234 82.974 8.07532 81.5245 8.07532H81.2805V9.60636ZM77.3123 11.4094H76.4438V9.60638H77.3123V4.10254H81.353C85.0152 4.10254 87.8234 5.9715 87.8234 10.6347C87.8234 14.4059 85.5362 16.7984 82.3365 16.7984H77.3123V11.4094Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5559 4.10242V12.6552C94.5559 15.1812 93.0205 16.9999 90.8328 16.9999C89.7041 16.9999 88.4594 16.4278 87.5757 15.6184L88.9235 11.6976C89.126 12.302 89.3567 13.0267 89.9799 13.0267C90.6173 13.0267 90.674 12.1847 90.674 11.6445V4.10242H94.5559Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.805 12.2005L101.342 9.96029C101.228 9.42288 101.156 8.86605 101.083 8.3269H100.938L100.214 12.2005H101.805ZM99.186 16.7984H94.9895L98.7796 4.10217H103.168L107.063 16.7984H102.865L102.501 15.215H99.5012L99.186 16.7984Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.972 4.10242H111.782L115.346 11.1401H115.461C115.3 10.0795 115.126 8.98523 115.126 7.90834V4.10242H118.92V16.7983H115.126L111.637 10.1287H111.523C111.651 11.0051 111.77 11.8308 111.77 12.6725V16.7983H107.972V4.10242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHusaText);
export default __webpack_public_path__ + "static/media/logo-husa-text.dc4a3060.svg";
export { ForwardRef as ReactComponent };